import React, { Component } from 'react'
import api from "../../config/api";
import { connect } from 'react-redux'
import {
  debitsComp,
  debitsSelectedComp,
  debitsSelectedIDsComp,
  openSnackComp,
} from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Box } from '@material-ui/core';
import MenuDebitsManager from '../../components/MenuDebitsManager'
import FilterBanks from '../../components/FilterBanks';
import LoadingDefault from '../../components/LoadingDefault';
import TableBanks from '../../components/TableBanks';
import Snackbar from '../../components/Snackbar';
import ContentNotLoaded from '../../components/ContentNotLoaded';
import { errorDefault } from '../../helper/errorDefault';

const styles = () => ({
  container: {
    padding: '0px 30px 20px 30px',
    marginTop: '130px'
  },
  menuGroup: {
    display: 'flex',
    width: '100%',
    marginTop: '10px',
    marginBottom: '30px',
    padding: '20px 0px 0px 0px',
  },
  menuIcon: {
    width: 30,
    marginRight: 7
  },
  linkGroup: {
    textDecoration: 'none',
  },
  button: {
    color: 'rgb(24, 116, 185)',
    fontSize: 17,
    background: 'none',
    border: 'none',
    boxShadow: 'none',
  },
  loadingDiv: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  marginBottom: {
    marginBottom: 40,
  },
})

export class ListBanks extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingBanks: false,
      errorLoadingBanks: false,
      errorMessage: '',
      snackBarMessage: '',
      banksList: [],
      filteredBanksList: [],
      listBanksFiltered: []
    }
  }

  componentWillMount() {
    this.props.openSnackComp(false)
    this.props.debitsComp([])
    this.props.debitsSelectedComp([])
    this.props.debitsSelectedIDsComp([])
  }

  componentDidMount() {
    this.getBanksList()
  }

  async getBanksList() {
    this.setState({
      loadingBanks: true,
      errorMessage: '',
      errorLoadingBanks: false,
      snackBarMessage: '',
      banksList: [],
      filteredBanksList: [],
    }, () => {
      this.props.openSnackComp(false)
    })

    try {
      let opcaoConsultaBancos = 4
      const getBancosResponse = await api.get("Bancos/Consultar?opcao=" + opcaoConsultaBancos)

      let lstBancos = []

      if (getBancosResponse.data !== null && getBancosResponse.data !== undefined) {
        lstBancos = getBancosResponse.data

        this.setState({
          banksList: lstBancos,
          filteredBanksList: lstBancos,
          loadingBanks: false
        })
      }
    } catch (error) {
      let errorMessage = errorDefault(error)

      this.setState({
        errorMessage: errorMessage,
        errorLoadingBanks: true,
        loadingBanks: false,
      });
    }
  }

  getBanksFiltered = filterParams => {
    let filteredList = this.state.banksList

    if (filterParams !== null && filterParams !== undefined && filterParams !== '') {
      if (!isNaN(filterParams.filterCodigoBanco)) {
        this.setFilteredBanksList(filteredList.filter(x => x.CodigoBanco === filterParams.filterCodigoBanco))
      }

      if (isNaN(filterParams.filterCodigoBanco) && filterParams.filterDebitoAutomatico) {
        this.setFilteredBanksList(filteredList.filter(x => x.PermiteDebitoAutomatico))
      }

      if (!isNaN(filterParams.filterCodigoBanco) && filterParams.filterDebitoAutomatico) {
        this.setFilteredBanksList(filteredList.filter(x => x.PermiteDebitoAutomatico &&
          x.CodigoBanco === filterParams.filterCodigoBanco))
      }
    } else {
      this.setFilteredBanksList(filteredList)
    }

  }

  setFilteredBanksList(listBanks) {
    this.setState({
      filteredBanksList: listBanks, listBanksFiltered: listBanks
    })
  }

  editBank = banco => {
    this.props.history.push({
      pathname: "/editar-banco",
      state: {
        selectedBank: banco,
        readOnly: true
      }
    })
  }

  render() {
    const { classes } = this.props;
    const { snackBarMessage, loadingBanks, errorLoadingBanks, errorMessage } = this.state;

    return (
      <div>
        <Snackbar
          message={snackBarMessage}
        />

        <Grid container className={classes.container}>
          <MenuDebitsManager />

          <Box width={1}>
            <FilterBanks loadingBanks={loadingBanks} GetBanksFiltered={this.getBanksFiltered} ddlData={this.state.banksList} />
          </Box>

          {/* TODO: Link to CADASTRAR BANCO */}
          {/* <Link className={classes.linkGroup} to={{
            pathname: "/editar-banco",
            state: {
              isEditing: false
            }
          }}>
            <Box width={1} marginTop={2}>
              <Box display="flex" justifyContent="flex-end">
                <ButtonTypeName typeButton={4}/>
              </Box>
            </Box>
          </Link> */}

          {loadingBanks && (
            <div className={classes.loadingDiv}>
              <LoadingDefault typeLoading={'card'} />
            </div>
          )}

          {this.state.filteredBanksList.length === 0 && !loadingBanks && !errorLoadingBanks &&
            <ContentNotLoaded message={"Não foram encontrados bancos cadastrados no sistema."} />
          }

          {errorLoadingBanks &&
            <ContentNotLoaded message={errorMessage} />
          }

          {this.state.filteredBanksList.length > 0 &&
            <Box width={1}>
              <TableBanks tableData={this.state.filteredBanksList} tableFilter={this.state.listBanksFiltered} navigateToEdit={this.editBank} />
            </Box>}          
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  openSnackValue: store.cardDebitState.openSnackValue,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    debitsComp,
    debitsSelectedComp,
    debitsSelectedIDsComp,
    openSnackComp,
  }, dispatch);

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ListBanks)
);
